import barba from "@barba/core";

import { DesktopNavigation } from "./components/DesktopNavigation.js";
import { Logo } from "./components/Logo.js";
import {
  MobileMenuButton,
  initMobileMenuButton,
} from "./components/MobileMenuButton.js";
import { MobileNavigation } from "./components/MobileNavigation.js";

import { Footer } from "./components/Footer.js";

const footerMount = document.querySelector("[data-footer]");

if (footerMount) {
  footerMount.replaceWith(Footer());
}

const logoMount = document.querySelector("[data-logo]");
const desktopNavMount = document.querySelector("[data-desktop-navigation]");
const mobileButtonMount = document.querySelector("[data-mobile-menu-button]");
const mobileNavMount = document.querySelector("[data-mobile-navigation]");

if (logoMount) {
  logoMount.replaceChildren(Logo());
}

if (desktopNavMount) {
  desktopNavMount.replaceWith(DesktopNavigation());
}

let mobileNav;

if (mobileNavMount) {
  mobileNav = MobileNavigation();
  mobileNavMount.replaceWith(mobileNav);
}

if (mobileButtonMount) {
  const mobileButton = MobileMenuButton();

  mobileButtonMount.replaceWith(mobileButton);

  if (mobileNav) {
    initMobileMenuButton(mobileButton, mobileNav);
  }
}

const siteHeader = document.querySelector(".site-header");

if (siteHeader) {
  const syncHeaderHeight = () => {
    const height = Math.ceil(siteHeader.getBoundingClientRect().height);
    document.documentElement.style.setProperty(
      "--site-header-height",
      `${height}px`,
    );
  };

  syncHeaderHeight();
  new ResizeObserver(syncHeaderHeight).observe(siteHeader);
  document.fonts?.ready.then(syncHeaderHeight);
}

function updateDocumentTitle(html) {
  if (!html) {
    return;
  }

  const nextDocument = new DOMParser().parseFromString(html, "text/html");

  if (nextDocument.title) {
    document.title = nextDocument.title;
  }
}

function resetPageScroll(container) {
  container
    ?.querySelectorAll(".work-bottom-container-mobile")
    .forEach((element) => {
      element.scrollTop = 0;
    });
}

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.append(textArea);
  textArea.select();

  const copied = document.execCommand("copy");
  textArea.remove();

  if (!copied) {
    throw new Error("Unable to copy text");
  }
}

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy-email]");

  if (!button) {
    return;
  }

  const email = button.dataset.copyEmail;
  const status = document.querySelector("#connect-copy-status");

  if (!email) {
    return;
  }

  try {
    await copyText(email);
    button.textContent = "Copied!";

    if (status) {
      status.textContent = "Email copied to clipboard.";
    }
  } catch {
    button.textContent = "COPY FAILED";

    if (status) {
      status.textContent = "Copy failed. Select the email address instead.";
    }
  }

  window.setTimeout(() => {
    if (button.isConnected) {
      button.textContent = "Copy Email";
    }
  }, 1800);
});

barba.hooks.beforeLeave(() => {
  document.body.classList.remove("nav-is-open");
});

barba.hooks.beforeEnter(({ next }) => {
  updateDocumentTitle(next.html);
  resetPageScroll(next.container);
});

barba.init({ preventRunning: true });
